import { CurrencyInput, HugerteEditor } from 'components/FormControl';
import PropTypes from 'prop-types';
import { useMutationRegisterResultMinute } from 'utils/hooks/registerResult';
import { toast } from 'layout';
import { REGISTER_RESULT_FILE_TYPE, TOAST } from 'constant';
import { formatFileName } from 'utils/func';
import UploadAppendixes from './UploadAppendixes';
import CustomFileUpload from './UploadFile';

export default function ExpenditureAndAppendix({
  control,
  errors,
  disabled,
  registerResultId,
  refetch,
  minuteFile,
  appendixeArray,
  handleDownloadFile,
  isLiquidation,
  onSubmit,
}) {
  const { mutateAsync } = useMutationRegisterResultMinute();

  const handleUploadFile = async (file) => {
    try {
      let idSent = registerResultId;
      if (!idSent) {
        idSent = await onSubmit();
      } else {
        await onSubmit();
      }
      const formData = new FormData();
      formData.append('file', file);
      await mutateAsync({ registerResultId: idSent, body: formData });
      toast(TOAST.SUCCESS, 'Tải lên biên bản thanh lý hợp đồng thành công');
      refetch();
    } catch (error) {
      toast(TOAST.ERROR, 'Tải lên biên bản thanh lý hợp đồng thất bại');
    }
  };
  return (
    <>
      <h4>Các khoản kinh phí</h4>
      <div className="flex flex-column lg:flex-row lg:gap-4 gap-2">
        <CurrencyInput
          label="Tổng số tiền quyết toán (VNĐ)"
          name="settlementAmount"
          control={control}
          errors={errors}
          readOnly={disabled}
        />

        <CurrencyInput
          label={isLiquidation ? 'Tổng số tiền thu hồi (VNĐ)' : 'Tổng số tiền tiết kiệm (VNĐ)'}
          name={isLiquidation ? 'recoveryAmount' : 'savingsAmount'}
          control={control}
          errors={errors}
          readOnly={disabled}
        />
      </div>

      {isLiquidation && (
        <>
          <h4 className="m-0">Ghi chú</h4>
          <HugerteEditor name="note" control={control} errors={errors} readOnly={disabled} />
        </>
      )}

      <h4 className="mb-0">
        Biên bản thanh lý {isLiquidation ? 'không' : ''} hợp đồng
        <span className="ml-1 text-red-500">*</span>
      </h4>
      {!disabled && (
        <CustomFileUpload
          name="expenditureAndAppendix"
          disabled={disabled}
          maxFileSize={30000000}
          acceptOnly="pdfOnly"
          onUpload={handleUploadFile}
        />
      )}

      {minuteFile && (
        <span
          className="p-button p-button-text p-button-sm mt-1 p-0"
          onClick={() => {
            handleDownloadFile(minuteFile, REGISTER_RESULT_FILE_TYPE.MINUTE);
          }}
        >
          <i className="pi pi-file-pdf text-red-500 text-xl" />{' '}
          <span className="text-blue-500 underline font-italic ml-1">
            {formatFileName(minuteFile)}
          </span>
        </span>
      )}

      <UploadAppendixes
        disabled={disabled}
        control={control}
        errors={errors}
        appendixeArray={appendixeArray}
        handleDownloadFile={handleDownloadFile}
        registerResultId={registerResultId}
        refetch={refetch}
        onSubmit={onSubmit}
      />
    </>
  );
}

ExpenditureAndAppendix.propTypes = {
  control: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}).isRequired,
  disabled: PropTypes.bool,
  registerResultId: PropTypes.string,
  refetch: PropTypes.func,
  minuteFile: PropTypes.string,
  appendixeArray: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      filename: PropTypes.string,
    })
  ),
  handleDownloadFile: PropTypes.func,
  isLiquidation: PropTypes.bool,
  onSubmit: PropTypes.func,
};

ExpenditureAndAppendix.defaultProps = {
  disabled: false,
  registerResultId: null,
  refetch: () => null,
  minuteFile: null,
  appendixeArray: [],
  handleDownloadFile: () => null,
  isLiquidation: false,
  onSubmit: () => null,
};
